/** Whether this login flow created the clinic's patient record, not appointment history. */
export enum PatientAuthType {
  NEW = "NEW",
  EXISTING = "EXISTING",
}
